import React, { useState } from 'react'

import { REPEAT_BOOKING, REPEAT_TOGGLE } from '../../../../helpers'
import { COLOR } from '../../../../themes'
import { StylesRepeatToggle } from './styles'

const RepeatToggle = (props) => {
  const {
    isRepeat,
    language,
    setIsRepeat,
    colorTheme
  } = props

  const defaultSelected = isRepeat ? 'on' : 'off'
  const [selectedKey, setSelectedKey] = useState(defaultSelected)

  const onPressToggle = (key) => {
    if (key === 'on') {
      setIsRepeat(true)
    } else {
      setIsRepeat(false)
    }

    setSelectedKey(key)
  }

  const Toggle = ({ list, onPressToggle, theme = COLOR.GOLD_1 }) => list.map((item) => {
    const isSelected = selectedKey === item.key
    const color = isSelected ? theme : COLOR.WHITE

    return (
      <div
        className='options'
        key={item.key}
        onClick={() => onPressToggle(item.key)}
      >
        <input
          style={{ color }}
          type='radio'
          value={item[language]}
          checked={isSelected}
          readOnly
        />
        <label className='option-text'>{item[language]}</label>
      </div>
    )
  })

  return (
    <>
      <StylesRepeatToggle colorTheme={colorTheme}>
        <label className='title'>{REPEAT_BOOKING.REPEAT[language]}</label>

        <div className='radio-layout'>
          <Toggle list={REPEAT_TOGGLE} onPressToggle={onPressToggle} theme={colorTheme} />
        </div>
      </StylesRepeatToggle>
      <div style={{ color: '#525252', fontSize: 14, marginTop: 10 }}>{REPEAT_BOOKING.NOTE[language]}</div>
    </>
  )
}

export default RepeatToggle
